import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from "firebase/analytics";


// Configuração do Firebase
// Lê as credenciais do arquivo .env
const firebaseConfig = {
  apiKey: "AIzaSyDXcs0UGqe_b7pJi-psH44ZivKhPdRCcaE",
  authDomain: "memoria-imortais.firebaseapp.com",
  projectId: "memoria-imortais",
  storageBucket: "memoria-imortais.firebasestorage.app",
  messagingSenderId: "430786475566",
  appId: "1:430786475566:web:7beb532de4b41c08e251bf",
  measurementId: "G-NJJNY8YMBY"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

// Inicializar Firestore
const db = getFirestore(app);

// Inicializar Storage
const storage = getStorage(app);

export { db, storage };


